const es = {
  ETAPAS: "ETAPAS",
  NOSOTROS: "NOSOTROS",
  "TALENTO P5": "TALENTO P5",
  "PREGUNTAS FRECUENTES": "PREGUNTAS FRECUENTES",
  "Aplicá 🚀": "Aplicá 🚀",
  "Aprendé a programar. Cambiá tu vida": "Aprendé a programar. Cambiá tu vida",
  "Te acompañamos desde tus primeros pasos hasta un trabajo en IT.":
    "Te acompañamos desde tus primeros pasos hasta un trabajo en IT.",
  "Aplicá ahora": "Aplicá ahora",
  "Ranking promedio": "Ranking promedio",
  salesforceBootcamp: {
    "Salesforce Bootcamp": "Salesforce Bootcamp",
    "Aprendé a programar en Salesforce, la plataforma de CRM más grande del mundo.":
      "Aprendé a programar en Salesforce, la plataforma de CRM más grande del mundo.",
    "Quiero aplicar": "Quiero aplicar",
    "Powered by": "Powered by",
    "Salesforce es la plataforma de CRM (Customer Relationship Management) nº 1 líder del mercado. Dominá esta tecnología y desarrollará sistemas de gestión de clientes para grandes empresas.":
      "Salesforce es la plataforma de CRM (Customer Relationship Management) nº 1 líder del mercado. Dominá esta tecnología y desarrollará sistemas de gestión de clientes para grandes empresas.",
    BENEFICIOS: "BENEFICIOS",
    "Por qué hacerlo": "Por qué hacerlo",
    "100% inserción laboral": "100% inserción laboral",
    "Todos nuestros graduados que buscaron trabajo al terminar el Bootcamp lo consiguieron.":
      "Todos nuestros graduados que buscaron trabajo al terminar el Bootcamp lo consiguieron.",
    SALARIOS: "SALARIOS",
    "Muy poca gente domina esta tecnología, lo que pone a los programadores de Salesforce entre los mejores pagos del mercado IT.":
      "Muy poca gente domina esta tecnología, lo que pone a los programadores de Salesforce entre los mejores pagos del mercado IT.",
    "9,3 MILLONES DE NUEVOS PUESTOS DE TRABAJO":
      "9,3 MILLONES DE NUEVOS PUESTOS DE TRABAJO",
    "Con más de 160.000 empresas que tienen como clientes, Salesforce es una de las tecnologías de mayor crecimiento en el mundo.":
      "Con más de 160.000 empresas que tienen como clientes, Salesforce es una de las tecnologías de mayor crecimiento en el mundo.",
    INTENSIVO: "INTENSIVO",
    "Modalidad de cursada": "Modalidad de cursada",
    "FULL TIME": "FULL TIME",
    DURACIÓN: "DURACIÓN",
    REMOTO: "REMOTO",
    "Lunes a viernes De 9 a 19 hs.": "Lunes a viernes De 9 a 19 hs.",
    "4 meses Más de 800 horas de aprendizaje":
      "4 meses Más de 800 horas de aprendizaje",
    "Clases online en vivo": "Clases online en vivo",
    "CONOCÉ MÁS": "CONOCÉ MÁS",
    PROGRAMA: "PROGRAMA",
    "Unidad 1": "Unidad 1",
    "Unidad 2": "Unidad 2",
    "Unidad 3": "Unidad 3",
    "2 semanas": "2 semanas",
    "Introducción a Salesforce y su Arquitectura":
      "Introducción a Salesforce y su Arquitectura",
    "Modelo de Datos en Salesforce": "Modelo de Datos en Salesforce",
    "Salesforce Platform Basics": "Salesforce Platform Basics",
    "Lightning Experience en CRM": "Lightning Experience en CRM",
    "Data Modeling": "Data Modeling",
    "Salesforce Security": "Salesforce Security",
    "Automation Tools": "Automation Tools",
    "Salesforce Development Lifecycle": "Salesforce Development Lifecycle",
    "SFDX & Salesforce CLI + Visual Studio Code Extensions":
      "SFDX & Salesforce CLI + Visual Studio Code Extensions",
    "Apex Basics & Database": "Apex Basics & Database",
    "Apex Triggers": "Apex Triggers",
    "Asynchronous Apex": "Asynchronous Apex",
    "Apex Development Patterns": "Apex Development Patterns",
    "Native Javascript": "Native Javascript",
    "Lightning Web Components Basics (LWC)":
      "Lightning Web Components Basics (LWC)",
    "LWC & Salesforce Data": "LWC & Salesforce Data",
    "Comunicación Entre LWCs (Eventos)": "Comunicación Entre LWCs (Eventos)",
    "LWC Escalabilidad": "LWC Escalabilidad",
    "Descargar programa": "Descargar programa",
    HERRAMIENTAS: "HERRAMIENTAS",
    "Aprenderás a usar": "Aprenderás a usar",
    FINANCIACIÓN: "FINANCIACIÓN",
    "Pagá sólo cuando consigas tu primer trabajo":
      "Pagá sólo cuando consigas tu primer trabajo",
    "Nuestros graduados acceden a los mejores sueldos del mercado y duplican sus ingresos en un año.":
      "Nuestros graduados acceden a los mejores sueldos del mercado y duplican sus ingresos en un año.",
    "El 70 % de nuestros alumnos están financiados y consiguen trabajo en menos de 3 meses. ":
      "El 70 % de nuestros alumnos están financiados y consiguen trabajo en menos de 3 meses. ",
    "Elegí tu Bootcamp y empezá a pagarlo hasta en 24 pagos mensuales cuando consigas tu primer trabajo en IT.":
      "Elegí tu Bootcamp y empezá a pagarlo hasta en 24 pagos mensuales cuando consigas tu primer trabajo en IT.",
    "Podés pagar cuando consigas tu primer trabajo️":
      "Podés pagar cuando consigas tu primer trabajo️",
    "DE CONTADO": "DE CONTADO",
    DIFERIDO: "DIFERIDO",
    "FULL DIFERIDO": "FULL DIFERIDO",
    "Pago inicial": "Pago inicial",
    "Al conseguir trabajo": "Al conseguir trabajo",
    Cuotas: "Cuotas",
    Ahorrás: "Ahorrás",
    Aplicar: "Aplicar",
    "ABRIL 2022 | ONLINE - EN VIVO": "ABRIL 2022 | ONLINE - EN VIVO",
    "Cierre de inscripción: 00/00/00": "Cierre de inscripción: 00/00/00",
    "Fechas: 00/00/00 a 00/00/00": "Fechas: 00/00/00 a 00/00/00",
    "Horario: de 09:30 a 19:30": "Horario: de 09:30 a 19:30",
    "Duración: 15 semanas (710 horas)": "Duración: 15 semanas (710 horas)",
    "Modalidad: full-time": "Modalidad: full-time",
    "Días: lunes a viernes": "Días: lunes a viernes",
    "Nivel: avanzado": "Nivel: avanzado",
    "ÚLTIMAS VACANTES": "ÚLTIMAS VACANTES",
    "Un día típico": "Un día típico",
    "Durante las primeras 6 semanas del Salesforce Bootcamp. (Formación inicial) Programa 100% virtual.":
      "Durante las primeras 6 semanas del Salesforce Bootcamp. (Formación inicial) Programa 100% virtual.",
    "9:30 AM |  PREPARACIÓN DEL DÍA Y REPASO":
      "9:30 AM |  PREPARACIÓN DEL DÍA Y REPASO",
    "10:00 AM | LECTURES": "10:00 AM | LECTURES",
    "En las lectures (clases teóricas) los profesores explicarán nuevos conceptos, con los que tendrás que trabajar después. Estas pueden ser en vivo o grabadas.":
      "En las lectures (clases teóricas) los profesores explicarán nuevos conceptos, con los que tendrás que trabajar después. Estas pueden ser en vivo o grabadas.",
    "11:00 AM | WORKSHOP": "11:00 AM | WORKSHOP",
    "Durante el Workshop tendrás que realizar tareas, resolver problemas y profundizar tu conocimiento sobre algunos conceptos vistos en las lectures. A veces trabajarás de modo individual y a veces en equipos":
      "Durante el Workshop tendrás que realizar tareas, resolver problemas y profundizar tu conocimiento sobre algunos conceptos vistos en las lectures. A veces trabajarás de modo individual y a veces en equipos",
    "13:00 AM |  ALMUERZO Y RELAX": "13:00 AM |  ALMUERZO Y RELAX",
    "14:00 AM | WORKSHOP (CONTINUACIÓN)": "14:00 AM | WORKSHOP (CONTINUACIÓN)",
    "Continuarás con el trabajo en las actividades y proyectos asignados y te prepararás para la sesión de consultas. Durante los Workshops contarás con la ayuda de asistentes para resolver tus inquietudes.":
      "Continuarás con el trabajo en las actividades y proyectos asignados y te prepararás para la sesión de consultas. Durante los Workshops contarás con la ayuda de asistentes para resolver tus inquietudes.",
    "17:00 PM | Q&A: SESIÓN DE CONSULTAS":
      "17:00 PM | Q&A: SESIÓN DE CONSULTAS",
    "Esta sesión será grupal y en vivo. Te permitirá despejar tus dudas con los profesores, aprovechar las consultas de los demás y consolidar los aprendizajes del día.":
      "Esta sesión será grupal y en vivo. Te permitirá despejar tus dudas con los profesores, aprovechar las consultas de los demás y consolidar los aprendizajes del día.",
    "18:00 PM | WORKSHOP": "18:00 PM | WORKSHOP",
    "Continuarás con las tareas asignadas y harás las entregas indicadas para esa jornada.":
      "Continuarás con las tareas asignadas y harás las entregas indicadas para esa jornada.",
    "*A partir de la semana 7, este cronograma tendrá algunas modificaciones, pero las actividades seguirán siendo full-time.":
      "*A partir de la semana 7, este cronograma tendrá algunas modificaciones, pero las actividades seguirán siendo full-time.",
    TESTIMONIOS: "TESTIMONIOS",
    "El Bootcamp en P5 es una experiencia hermosa. Los profesores explican muy bien y siempre están a disposición. Es un cambio de vida total, te abre muchos caminos en el mundo IT. ¡Salesforce es enorme y está lleno de oportunidades!":
      "El Bootcamp en P5 es una experiencia hermosa. Los profesores explican muy bien y siempre están a disposición. Es un cambio de vida total, te abre muchos caminos en el mundo IT. ¡Salesforce es enorme y está lleno de oportunidades!",
    "El Bootcamp en P5 fue una de mis mejores experiencias. Si alguien quiere hacer un salto en su carrera y está comprometido con eso, se lo recomiendo al 100 %. Requiere mucha dedicación, pero es muy llevadero, no te aburrís y te sentís acompañado. Además, como Salesforce es un mundo gigante, hay muchísimas áreas para desarrollarse laboralmente.":
      "El Bootcamp en P5 fue una de mis mejores experiencias. Si alguien quiere hacer un salto en su carrera y está comprometido con eso, se lo recomiendo al 100 %. Requiere mucha dedicación, pero es muy llevadero, no te aburrís y te sentís acompañado. Además, como Salesforce es un mundo gigante, hay muchísimas áreas para desarrollarse laboralmente.",
    "Mi experiencia en P5 fue espectacular. ¡Un Bootcamp te permite dar un salto enorme! No sabía nada de programación y me convertí en developer. En P5 intentan que cada proyecto parezca un trabajo real, lo que te diferencia en el mercado laboral. ¡El Bootcamp de Salesforce es una superoportunidad!":
      "Mi experiencia en P5 fue espectacular. ¡Un Bootcamp te permite dar un salto enorme! No sabía nada de programación y me convertí en developer. En P5 intentan que cada proyecto parezca un trabajo real, lo que te diferencia en el mercado laboral. ¡El Bootcamp de Salesforce es una superoportunidad!",
  },
  AboutUs: {
    HeroSection: {},
  },
  Faqs: [
    {
      section: "TUS PREGUNTAS",
      title: "Curso Introductorio",
      questions: [
        {
          question:
            "¿Cuál es la diferencia entre el Curso Introductorio con Profesor y el ATR?",
          text: [
            "El Curso Introductorio de Programación tiene dos modalidades: ATR y con Profesor. **El contenido es el mismo.** La diferencia es que con el ATR cursás **A Tu Ritmo (asincrónico)** mientras que con Profesor tenés tres clases sincrónicas por semana con profesores y asistentes. El ATR lo empezás y terminás cuando querés **y con Profesor la duración es de seis semanas.**",
          ],
        },
        {
          question: "¿Hay un límite de edad para anotarme?",
          text: [
            "No. Para nosotros **la edad no es una limitante** y consideramos que tampoco lo es para insertarse laboralmente en el rubro de IT. La edad de nuestros estudiantes va desde 16 años hasta más de 55 años.",
          ],
        },
        {
          question: "¿Qué computadora necesito para cursar?",
          text: [
            "Para realizar el Curso Introductorio podés utilizar cualquier sistema operativo (Linux, Windows, Mac). Una **notebook con un procesador Intel Core i3 y 4GB de memoria RAM está perfecto.**",
            "Si tenés pensado hacer un Coding Bootcamp te recomendamos ya tener una computadora con un procesador i5, 8GB de memoria RAM y 125 GB de memoria disponible en el disco.",
            "Además, tené en cuenta que para el JavaScript Bootcamp se requiere el uso de sistema operativo Linux o Mac.",
          ],
        },
        {
          question: "¿Entregan una certificación al terminar?",
          text: [
            "Sí. En Plataforma 5 apuntamos a un nuevo sistema educativo centrado en la práctica y en los resultados demostrables.",
            "Una vez que hayas finalizado el Curso Introductorio y entregado los proyectos prácticos a desarrollar, **recibirás un certificado** que avala los conocimientos adquiridos.",
          ],
        },
        {
          question: "¿Puedo conseguir trabajo luego del Curso Introductorio?",
          text: [
            "En el Curso Introductorio trabajás con el **front-end de sitios y aplicaciones web**, algo que tiene mucha demanda en el mercado laboral.",
            "Sin embargo, si tu objetivo es  insertarte en el mundo IT y dar un salto de carrera, te recomendamos nuestros **Coding Bootcamps.** Podrás convertirte en Full Stack Developer especializado en JavaScript o en Salesforce.",
          ],
        },
        {
          question: "¿Hay clases en vivo para las personas que cursamos ATR?",
          text: [
            "No. Contamos con clases grabadas en Youtube para reforzar tus conocimientos.",
          ],
        },
        {
          question:
            "¿A quién le puedo consultar mis dudas técnicas si estoy cursando ATR?",
          text: [
            "Utilizamos la plataforma **Discord** para comunicarnos. Podés escribir en los canales específicos y la Comunidad P5 te ayudará en lo que necesites. Asimismo, te sugerimos contestar preguntas de otras personas, mirar y comentar trabajos e inspeccionar su código para seguir aprendiendo de manera colaborativa.",
          ],
        },
        {
          question: "¿Puedo cambiarme de “ATR” a “Con Profesor”?",
          text: [
            "Sí. Para hacerlo, envíanos un mail a admisiones@plataforma5.la",
            "Se te cobrará el monto diferencial que hay entre las dos modalidades.",
          ],
        },
        {
          question:
            "¿Si apruebo el Curso Introductorio tengo que hacer el Coding Challenge?",
          text: [
            "Sí. El Curso Introductorio te brinda las herramientas necesarias para rendir el Coding Challenge. Sin embargo, todas **las personas que quieran ingresar a nuestros Coding Bootcamps deben aprobar el examen técnico de admisión.**",
          ],
        },
      ],
    },
    {
      section: "TUS PREGUNTAS",
      title: "Coding Challenge",
      questions: [
        {
          question: "¿Qué es el Coding Challenge?",
          text: [
            "El Coding Challenge es el examen técnico de admisión a nuestros Coding Bootcamps.",
            "Si ya dominás los conceptos del Curso Introductorio, iniciá tu proceso de admisión a nuestros Coding Bootcamps completando el formulario de ejercicios nivelatorios.",
          ],
        },
        {
          question: "¿Qué temas entran en el Coding Challenge?",
          text: [
            "**Variables, If/Else, While y For Loops, Funciones, Arreglos y Objetos de JavaScript.**",
            "Practicá mucho cada uno de estos temas hasta dominarlos para tener éxito en tu Challenge.",
          ],
        },
        {
          question: "¿El proceso de admisión al Coding Bootcamp es gratuito?",
          text: [
            "**Sí.** El proceso de admisión al Coding Bootcamp **es completamente gratuito.** ",
          ],
        },
        {
          question: "¿Cómo es la dinámica del Coding Challenge?",
          text: [
            "Es un **examen sincrónico** de 5 ejercicios que escalan en dificultad. Se realiza **a través de una videollamada** en día y horario a pactar. Durante la hora que dura el examen deberás compartir tu pantalla.",
          ],
        },
        {
          question:
            "¿El Coding Challenge es el mismo para el JavaScript Bootcamp o el Salesforce Bootcamp?",
          text: [
            "Sí. **El proceso de admisión es el mismo** para todos los Coding Bootcamps.",
          ],
        },
        {
          question: "¿Puedo rendir el Coding Challenge más de una vez?",
          text: [
            "Sí. El Coding Challenge puede rendirse **hasta dos veces** en cada edición de Bootcamp.",
          ],
        },
        {
          question:
            "Si no pude entrar en una edición del Coding Bootcamp, ¿puedo volver a hacer la admisión en otro momento?",
          text: [
            "Sí. Es muy importante que quienes aspiren a ingresar a nuestros Coding Bootcamps sean perseverantes y mantengan el foco en sus objetivos.",
            "En caso de que **no apruebes la admisión técnica**, vamos a delinear juntos un **camino** para que puedas reforzar los conocimientos y **volver a intentarlo.** ",
          ],
        },
      ],
    },
    {
      section: "TUS PREGUNTAS",
      title: "Coding Bootcamp",
      questions: [
        {
          question: "¿Qué es un Coding Bootcamp?",
          text: [
            "Un **Coding Bootcamp** es un **curso intensivo de programación** de dedicación full-time que desarrolla tu talento y te inserta en el mercado laboral.",
            "Te formamos como **Full Stack Developer** (en JavaScript o Salesforce), un perfil de programador muy requerido en la industria del software. Vas a aprender a trabajar en equipo, incorporando las  **metodologías ágiles** en tu rutina diaria.",
            "En el último mes, aplicarás lo aprendido en **proyectos profesionales**. De esta manera, y de la mano de tus mentores técnicos, vas a ir sumando la experiencia necesaria para **conseguir tu primer trabajo.**",
          ],
        },
        {
          question:
            "¿Cuál es la diferencia entre el JavaScript y el Salesforce Bootcamp?",
          text: [
            "Aunque comparten el mismo proceso de admisión, horarios y modalidad de cursada, **el foco de cada Bootcamp está puesto en tecnologías diferentes.**",
            "**Salesforce** es un servicio que provee herramientas de CRM para las empresas. Se refiere al conjunto de prácticas, estrategias de negocio y tecnologías enfocadas en la relación con el cliente.",
            "**JavaScript** es un lenguaje de programación versátil que te brinda la habilidad de desarrollar tanto el frond-end como el back-end de sitios y aplicaciones web. Es el lenguaje más utilizado a nivel mundial.",
          ],
        },
        {
          question: "¿Los Coding Bootcamps tienen la misma duración?",
          text: [
            "Sí. Ambos respetan la **misma estructura y duración:**",
            "**• Bootcamp Prep:** Módulo de preparación donde incorporás herramientas fundamentales para comenzar el Coding Bootcamp. Duración: 3-4 semanas.",
            "**• Coding Bootcamp:** Clases teóricas, pair-programming, workshops y reviews para que incorpores los conceptos y  las herramientas FullStack. Duración: 14 semanas.",
            "**• Job Placement:** Te ayudamos a construir tu perfil profesional para potenciar tu inserción laboral. Duración: 2-3 semanas.",
            "_*Tanto el Bootcamp Prep como la etapa de Job Placement tienen una carga horaria part-time._",
          ],
        },
        {
          question: "¿Hay opciones de financiación para los Coding Bootcamps?",
          text: [
            "Sí. Contamos con **tres planes:**",
            "**Pago Full Diferido:** ¡Financiamos el 100% de tu Bootcamp! Empezá a pagar recién cuando consigas tu primer empleo, en hasta 24 cuotas. El valor total es de USD 4.500.",
            "**Pago Diferido:** Aboná un pago inicial mínimo de USD 600 y , el monto restante, lo empezás a pagar recién cuando conseguís tu primer empleo, en hasta 24 cuotas. El valor total es de USD 4.300. ",
            "**Pago De Contado:** Aboná antes de iniciar el Coding Bootcamp en un único pago y aprovechá un descuento. El valor total es de USD 3.900. Ahorrás USD 600.",
          ],
        },
        {
          question: "¿Es requisito hablar inglés?",
          text: [
            "**El inglés no es requisito obligatorio**, pero te ayudará a comprender mejor la documentación y te permitirá acceder a material complementario para tu formación. Tené en cuenta también que algunas empresas pueden solicitar un nivel intermedio de inglés en sus búsquedas. ",
          ],
        },
        {
          question: "¿Qué computadora necesito?",
          text: [
            "En el JavaScript Bootcamp utilizamos Linux o Mac. En cambio, en el de Salesforce, al ser todo Cloud, no se requiere un sistema operativo en particular.",
            "En ambos Bootcamps necesitás una **computadora con procesador i5, 8GB de memoria RAM y 125 GB de memoria disponible en el disco** es lo más conveniente. Si el presupuesto te lo permite, recomendamos un procesador i7, 12 GB de memoria RAM y 256 GB de memoria disponible.",
          ],
        },
        {
          question: "¿Me ayudan a conseguir trabajo?",
          text: [
            "En P5 **nos comprometemos a potenciar la búsqueda de empleo** de quienes egresan de nuestros Bootcamps.",
            "De la misma forma, **las personas que realizan el Bootcamp deben buscar activamente trabajo** para incrementar sus chances de éxito.",
            "Nuestro objetivo principal es que el 100% de nuestros bootcampers se inserte en el mercado laboral IT.",
          ],
        },
        {
          question:
            "En los planes financiados, ¿se cobra un porcentaje fijo de mi sueldo?",
          text: [
            "No. Una vez que **consigas tu primer trabajo** y según tu tipo de actividad laboral, el equipo de Administración armará un esquema a tu medida, **con un plan de pagos de hasta 24 cuotas mensuales** y consecutivas (para los planes “Pago Diferido” y “Full Diferido”).",
            "Antes de comenzar el Coding Bootcamp, con la **firma del Acuerdo de Pago** se explicitan las pautas importantes respecto a los tiempos de devolución y los montos. De esta forma, le damos un marco a tu compromiso de pago.",
          ],
        },
        {
          question: "¿Qué pasa si no consigo trabajo?",
          text: [
            "Desde P5 te vamos a formar en todas las skills necesarias para implementar una estrategia de búsqueda laboral exitosa. Sin embargo, recae en vos la responsabilidad última de conseguir el trabajo, ya que sos vos quien va a buscar empleos, postularse e ir a las entrevistas. Al finalizar el bootcamp deberás asumir el compromiso de entrar en Búsqueda Laboral Activa (BLA) y perseverar en ella hasta lograr el objetivo de tu primer trabajo en IT. Si bien los tiempos de inserción varían caso a caso, todos nuestros graduados que perseveran en la búsqueda logran el objetivo.",
          ],
        },
      ],
    },
    {
      section: "TUS PREGUNTAS",
      title: "Job Placement",
      questions: [
        {
          question: "¿Qué significa Job Placement?",
          text: [
            "El área de Job Placement de Plataforma 5 interviene para acompañar a quienes egresan de un Bootcamp en su inserción laboral. El equipo te ofrecerá herramientas para el desarrollo de tu estrategia profesional: armado de CV, perfil en redes sociales laborales y entrevistas grupales con empresas (Recruiting Weeks).",
          ],
        },
        {
          question: "¿Qué implica buscar activamente trabajo?",
          text: [
            "Buscar activamente trabajo significa **realizar de manera sistematizada, periódica y proactiva acciones para aumentar la probabilidad de conseguir un primer empleo como developer.** Esto implica tener una estrategia de búsqueda, diseñar un plan con objetivos generales y específicos, y realizar acciones todos los días para acercarse a la meta planteada.",
          ],
        },
        {
          question: "¿Qué son las Recruiting Weeks?",
          text: [
            "A través de decenas de encuentros virtuales, breves y grupales, tendemos un **puente entre los bootcampers y una gran variedad de empresas empleadoras** para acercarlos a su primer trabajo.",
            "Además, organizamos **Webinars** sobre temas destacados para la industria de la programación o sobre recursos útiles para potenciar su inserción laboral.",
          ],
        },
      ],
    },
  ],
  aplicaMain: {
    "¿cual curso?": "¿En qué curso querés anotarte?",
    "por favor": "Por favor",
    "selecciona tu curso": "seleccioná tu curso",
    "quiero aplicar": "Quiero aplicar",
    "curso introductorio": "CURSO INTRODUCTORIO",
    "aprende curso introductorio":
      "Aprendé desde cero HTML, CSS, JavaScript, las bases de la programación.",
    "empezas de cero": "¿EMPEZÁS DE CERO?",
    "javascript bootcamp": "JAVASCRIPT BOOTCAMP",
    "aprende javascript":
      "Conquistá una de las tecnologías centrales de la web y convertite en un Developer Full Stack.",
    "salesforce bootcamp": "SALESFORCE BOOTCAMP",
    "aprende salesforce":
      "Aprendé Apex y el ecosistema Salesforce y dominá la plataforma de CRM más usada por las grandes empresas.",
    "sabes programar": "¿YA SABÉS PROGRAMAR?",
  },
};

export default es;
